/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mTab.vue?vue&type=template&id=af059770&scoped=true"
import script from "./mTab.vue?vue&type=script&lang=js"
export * from "./mTab.vue?vue&type=script&lang=js"
import style0 from "./mTab.vue?vue&type=style&index=0&id=af059770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af059770",
  null
  
)

export default component.exports